function crud() {
  return {
    controller: ['$scope', function($scope) {
      this.list = function() {
        return $scope.list.apply(this, arguments);
      };

      this.view = function() {
        return $scope.view.apply(this, arguments);
      };

      this.edit = function() {
        return $scope.edit.apply(this, arguments);
      };

      this.remove = function() {
        return $scope.remove.apply(this, arguments);
      };

      this.save = function() {
        return $scope.save.apply(this, arguments);
      };

      this.saveAndList = function() {
        return $scope.saveAndList.apply(this, arguments);
      };

      this.saveAndView = function() {
        return $scope.saveAndView.apply(this, arguments);
      };

      this.listEnabled = function() {
        return $scope.listEnabled.apply(this, arguments);
      };

      this.createEnabled = function() {
        return $scope.createEnabled.apply(this, arguments);
      };

      this.viewEnabled = function() {
        return $scope.viewEnabled.apply(this, arguments);
      };

      this.editEnabled = function() {
        return $scope.editEnabled.apply(this, arguments);
      };

      this.removeEnabled = function() {
        return $scope.removeEnabled.apply(this, arguments);
      };

      this.saveEnabled = function() {
        return $scope.saveEnabled.apply(this, arguments);
      };

      this.cancelEnabled = function() {
        return $scope.cancelEnabled.apply(this, arguments);
      };

      this.createPermission = function() {
        return $scope.createPermission.apply(this, arguments);
      };

      this.editPermission = function() {
        return $scope.editPermission.apply(this, arguments);
      };

      this.removePermission = function() {
        return $scope.removePermission.apply(this, arguments);
      };

      this.createVisible = function() {
        return $scope.createVisible.apply(this, arguments);
      };

      this.editVisible = function() {
        return $scope.editVisible.apply(this, arguments);
      };

      this.removeVisible = function() {
        return $scope.removeVisible.apply(this, arguments);
      };
    }]
  };
}

export default crud;



/** WEBPACK FOOTER **
 ** ./src/app/crud/crud.directive.js
 **/